  <div class="w-full mb-8 shadow-md bg-white">
    <div class="flex flex-col p-6 md:p-14 gap-y-9 place-items-center">
      @defer() {
        <product-rating class="w-full flex justify-end my-[-10px] md:my-[-20px]" [product]="product()"></product-rating>
      }
      <h1 class="text-3xl xl:text-4xl md:font-medium opacity-80">{{ product().name }}</h1>
      <div class="flex w-full gap-x-4 items-center">
        <div class="w-full flex place-content-center">
          <cld-picture
          class="w-full h-[225px] md:w-[600px] md:h-[336px] 2xl:w-[800px] 2xl:h-[450px]"
          [title]="product().name" [image]="mainImage" [sourceMediaSizes]="[
          { w: 350, h: 225,resizeMode: 'pad'},
          { bp: 'md', w: 600, h: 336, resizeMode: 'pad'},
          { bp: '2xl', w: 800, h: 450, resizeMode: 'pad'}
          ]"
          [fallbackImage]="productFallbackImage"
          [lazyload]="false">
        </cld-picture>
          </div>
          <ul class="hidden lg:block list-none">
            @if (product().minQta) {
              <li><span class="font-bold" i18n>Minimum quantity:</span> {{product().minQta}}</li>
            }
            @if (product().material) {
              <li><span class="font-bold" i18n>Material:</span> {{product().material}}</li>
            }
            @if (product().certifications) {
              <li><span class="font-bold" i18n>Certifications:</span> {{product().certifications}}</li>
            }
            @if (product().deliveryTime) {
              <li><span class="font-bold" i18n>Average delivery time:</span> {{product().deliveryTime}}</li>
            }
            @if (product().dimensions) {
              <li><span class="font-bold" i18n>Overall dimensions:</span> {{product().dimensions}}</li>
            }
            @if (product().packaging) {
              <li><span class="font-bold" i18n>Packaging:</span> {{product().packaging}}</li>
            }
            @if (product().shipping) {
              <li><span class="font-bold" i18n>Shipping:</span> {{product().shipping}}</li>
            }
            @if (product().notes) {
              <li><span class="font-bold" i18n>Notes:</span> {{product().notes}}</li>
            }
          </ul>
        </div>
        @if (platform.isBrowser && product().images && product().images.length > 1) {
          <carousel
            class="!w-[300px] md:!w-[700px] !2xl:w-[1000px] !z-0"
            [cellWidth]="200"
            [arrowsOutside]="true">
            @for (image of product().images; track $index) {
              <div class="carousel-cell" (click)="changeImage(image)">
                <cld-picture
                  class="w-[120x] h-[120px]"
                  [image]="image"
                  [title]="product().name"
                  [fallbackImage]="productFallbackImage"
                  [lazyload]="true"
                  [sourceMediaSizes]="[{w: 120, h: 120, resizeMode: 'pad'}]">
                </cld-picture>
              </div>
            }
          </carousel>
        }
        <html-content
          class="w-full text-2xl font-light leading-8 my-8 descendant-a:underline hover:descendant-a:text-gray-500 max-w-[calc(100vw-78px)] overflow-x-auto" 
          [content]="product().description" />
  
      @if (product().video; as video) {
        <div class="w-full max-w-full flex place-content-center">
          <video *renderIf="{mediaSelector:'gt-sm'}"
            [src]="video | resizeVideoUrl:800"
            [height]="800 / video.aspect_ratio"
            width="800"
            controls>
          </video>
          <video *renderIf="{mediaSelector:'lt-md'}"
            [src]="video | resizeVideoUrl:400"
            [height]="400 / video.aspect_ratio"
            width="400"
            controls>
          </video>
        </div>
      }
  
      <div class="flex flex-col w-full mb-5">
        <!-- Save-last updated-share -->
        <div class="flex flex-col mb-10">
          <div class="flex flex-col md:flex-row md:justify-between gap-y-6 mb-5">
            @if (product) {
              <div class="flex flex-row grow items-center">
                <avatar class="mr-[10px]" [picture]="company.logo"
                  [url]="company | getCompanyUrl"
                  [sizes]="[{w: 48, h:48, resizeMode: 'avatar'}]">
                </avatar>
                <div class="flex flex-col gap-y-1 md:mr-[10px] text-lg font-light">
                  <div i18n>last updated on</div>
                  <div>{{product().updatedAt | date:'fullDate'}}</div>
                </div>
              </div>
            }

            <expo-button
              class="w-full md:w-auto"
              (click)="!isSavedProduct() ? toggleSaveProduct('save') : toggleSaveProduct('remove')">
              {{ !isSavedProduct() ? 'Save product' : 'Remove product' }}
            </expo-button>
          </div>
          
          @defer() {
            <!-- Share per responsive  -->
            <exp-share-buttons
              [url]="product() | getProductUrl:company:true"
              [title]="product().name"
              [description]="product().shortDescription"
              [image]="product().images[0]"
              [autoSetMeta]="false"
              class="md:hidden"/>
          }
          @defer () {
            <!-- Share md screen  -->
            <exp-share-buttons
              [show]="9"
              [url]="product() | getProductUrl:company:true"
              [title]="product().name"
              [description]="product().shortDescription"
              [image]="product().images[0]"
              [autoSetMeta]="false"
              class="hidden md:flex"/>
          }
        </div>
        
  
        <div class="flex flex-grow items-center gap-x-1">
          @if (isFallbackLanguage && platform.isBrowser) {
            <span class="translations-label" i18n>alternative translations:</span>
            <language-selector [enabledLanguages]="availableLanguages" [hideDisabled]="true"
              (selectedLanguageChanged)="fetchTranslation($event)" [selectedLanguage]="selectedLanguage">
            </language-selector>
          }
        </div>
        
  
        <!-- LAZY LOAD REQUEST -->
        @defer() {
          <product-request [company]="company" [product]="product()"></product-request>
        }

        <ng-container #productRequestCt></ng-container>
        <div class="flex flex-grow place-content-end p-2">
          <ng-container #productRatingCt></ng-container>
        </div>
  
      </div>
    </div>
  </div>
  
  <!-- LAZY LOAD PRODUCTS -->
  @defer () {
    <stand-products urlPrefix="../../products/" mode="component" [scaleUpOnRender]="false" itemListId="product_summary_list" [itemListName]="this.company.slug + '_product_summary_list'"></stand-products>
  }

  <ng-container #productsCt></ng-container>
